import Journeys from '@/pages/journeys';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/trial-expired/journeys')({
  component: Journeys,
});
